import {
  ConfigurationValues,
  getDefaultConfiguration,
} from '@cutr/constants/windows/windows';
import { CONFIGURATIONS_OPTIONS } from '@cutr/constants/windows/windows-configurations.ts';
import { useId } from 'react';
import { useTranslation } from 'react-i18next';

import { Label } from '@/windows/primitives/Label';
import { Select, SelectItem } from '@/windows/primitives/Select';

import { unboxLabel } from '../Configurations';
import { useConfigurations, useResolvedSystem } from '../ConfigurationsContext';
import { optionFilterBySystemAndClass } from '../inputs/ConfigurationSelect';
import { ConfigurationComponent } from '.';

const WIDTH_OPTIONS = CONFIGURATIONS_OPTIONS.sashBeamWidth.options;

const SashBeamWidthInput = () => {
  const { t } = useTranslation();
  const { configurations, dispatch } = useConfigurations();
  const system = useResolvedSystem();
  const labelId = useId();
  const inputId = useId();

  const options = WIDTH_OPTIONS.filter((o) =>
    optionFilterBySystemAndClass(o, { system })
  );

  const systemDefault = getDefaultConfiguration('sashBeamWidth', system).top;

  const current = configurations.sashBeamWidth?.top;
  const selected =
    options.find((o) => o.value === current?.value) ?? systemDefault;

  return (
    <>
      <Label id={labelId} htmlFor={inputId}>
        {t('windows.configurations.sashBeamWidth.label')}
      </Label>
      <Select
        aria-labelledby={labelId}
        id={inputId}
        items={options}
        selectedKey={selected.value}
        onSelectionChange={(key) => {
          const newWidth = options.find((o) => o.value === key)!;
          dispatch({
            type: 'SET_SASH_BEAM_WIDTH',
            value: {
              top: newWidth,
              left: newWidth,
              right: newWidth,
              bottom: newWidth,
            },
          });
        }}
      >
        {(option) => (
          <SelectItem id={option.value} textValue={unboxLabel(option.label)}>
            <span>{unboxLabel(option.label)}</span>
          </SelectItem>
        )}
      </Select>
    </>
  );
};

const config: ConfigurationComponent<'sashBeamWidth'> = {
  key: 'sashBeamWidth',
  input: <SashBeamWidthInput />,
  display: (value: ConfigurationValues['sashBeamWidth']) => (
    <span>{value ? unboxLabel(value.top.label) : '-'}</span>
  ),
};

export default config;
